import { useEffect, useState } from 'react';

export const useBreakPoints = () => {
  const [isDesktop, setDesktop] = useState(false);
  let breakPoint: any;
  const updateMedia = () => {
    breakPoint = window.innerWidth >= 992;
    setDesktop(breakPoint);
  };

  useEffect(() => {
    updateMedia();
    window.addEventListener('resize', updateMedia);
    return () => {
      window.removeEventListener('resize', updateMedia);
    };
  });

  return isDesktop;
};
